export default __webpack_public_path__ + "static/media/BookaScreenHeroContainer.7c839e36.png";